import React, { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import ValidatorSelect from "../../../Validator/ValidatorSelect";
import _ from "lodash";
import useForm, { UseFormProps } from "../../../../hooks/useForm";
import Button from "@mui/material/Button";
import ApiClient from "../../../../services/ApiClient";
import { TextField } from "@mui/material";
import LegalbirdIoModal from "../../../Modal/LegalbirdIoModal";
import { apiPatch } from "../../../../services/Api/apiCall";
import { MediaObject } from "../../../../types/MediaObject";
import { Settlement } from "../../../../types/Products/EmploymentLaw/Settlement";

type SettlementRelatedMediaObjectsProps = {
  product: Settlement;
  mediaObjects: MediaObject[];
  refreshPage: Function;
};
const SettlementRelatedMediaObjects = ({ product, mediaObjects, refreshPage }: SettlementRelatedMediaObjectsProps) => {
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [requestDocumentText, setRequestDocumentText] = useState("");

  let initialValues: Record<string, any> = {
    contract: product.contract ? product.contract["@id"] : "__null__",
    contractTermination: product.contractTermination ? product.contractTermination["@id"] : "__null__",
  };

  const getDescription = (key: string) => {
    switch (key) {
      case "contract":
        return "Arbeitsvertrag";
      case "contractTermination":
        return "Kündigung";
      default:
        return null;
    }
  };

  const handleUpdate = async (withReset: boolean) => {
    await apiPatch("settlements", product.id, {
      contract: values.contract === "__null__" ? null : values.contract,
      contractTermination: values.contractTermination === "__null__" ? null : values.contractTermination,
      requestDocumentText: withReset ? requestDocumentText : null,
    });

    let updateMediaObjects: Promise<any>[] = [];
    _.forEach(values, (value, key) => {
      if (initialValues[key] !== value && product[key]) {
        updateMediaObjects.push(
          ApiClient.patch(product[key]["@id"], {
            body: JSON.stringify({
              description: product[key].description + " (ungültig)",
              fieldname: key + ".previous",
            }),
          })
        );

        let newDescription = getDescription(key);
        if (value !== "__null__" && newDescription) {
          updateMediaObjects.push(
            ApiClient.patch(value, {
              body: JSON.stringify({
                description: newDescription,
                fieldname: key,
              }),
            })
          );
        }
      }
    });

    Promise.all(updateMediaObjects).then(() => refreshPage());
  };

  const onSubmit: UseFormProps["onSubmit"] = async ({ values }) => {
    const reset = values.contract === "__null__" || values.contractTermination === "__null__";
    if (reset) {
      setConfirmationDialogOpen(true);
      return;
    }
    await handleUpdate(false);
  };

  const { values, handleChange, handleSubmit, handleBlur, touchedValues } = useForm({
    initialValues,
    onSubmit,
    identifier: mediaObjects,
  });

  return (
    <>
      <form onSubmit={handleSubmit}>
        <ValidatorSelect
          label={"Arbeitsvertrag"}
          name={"contract"}
          value={values.contract}
          onChange={handleChange}
          onBlur={handleBlur}
        >
          {_.map(mediaObjects, (mediaObject) => (
            <MenuItem
              key={mediaObject.id}
              value={mediaObject["@id"]}
              disabled={
                !!_.find(values, (value) => {
                  return value === mediaObject["@id"];
                })
              }
            >
              {mediaObject.description}
            </MenuItem>
          ))}
          <MenuItem value={"__null__"}>Erneut anfordern</MenuItem>
        </ValidatorSelect>
        <ValidatorSelect
          label={"Kündigung"}
          name={"contractTermination"}
          value={values.contractTermination}
          onChange={handleChange}
          onBlur={handleBlur}
        >
          {_.map(mediaObjects, (mediaObject) => (
            <MenuItem
              key={mediaObject.id}
              value={mediaObject["@id"]}
              disabled={
                !!_.find(values, (value) => {
                  return value === mediaObject["@id"];
                })
              }
            >
              {mediaObject.description}
            </MenuItem>
          ))}
          <MenuItem value={"__null__"}>Erneut anfordern</MenuItem>
        </ValidatorSelect>
        <br />
        <br />
        <br />
        <Button variant={"contained"} type={"submit"} disabled={_.keys(touchedValues).length === 0}>
          Speichern und Abschicken
        </Button>
      </form>
      <LegalbirdIoModal
        handleClose={() => setConfirmationDialogOpen(false)}
        open={confirmationDialogOpen}
        title={"Dokumente neu anfordern?"}
        submitButton={
          <Button
            variant={"contained"}
            disabled={requestDocumentText.length <= 30}
            onClick={() => {
              setConfirmationDialogOpen(false);
              handleUpdate(true);
            }}
          >
            Dokumente anfordern
          </Button>
        }
      >
        <p className={"center"}>
          Der Kunde erhält eine E-Mail, dass er etwas neu einreichen muss. Bitte geben Sie im Feld unten genau an, was
          noch fehlt und was der Kunde beim Hochladen der Dokumente beachten soll.{" "}
          <strong>Bitte auf Rechtschreibung achten - der Kunde erhält diesen Text als Hinweis in der Email!</strong>
        </p>
        <TextField
          label={"Begründung/Text an den Kunden"}
          multiline
          rows={8}
          value={requestDocumentText}
          onChange={({ target }) => setRequestDocumentText(target.value)}
          placeholder={"Hinweise/Anregungen an den Kunden, was fehlt oder was neu hochgeladen werden muss."}
        />
      </LegalbirdIoModal>
    </>
  );
};

export default SettlementRelatedMediaObjects;
